document.addEventListener("DOMContentLoaded", function(){


    const resetSquares = (container) => {
        
        let squareItems = container.querySelectorAll('.culture-squares__square');

        for(var i = 0; i < squareItems.length; i++) {
            squareItems[i].classList.remove('culture-squares__square--focus');
        }
    }

    const removeFocusSquare = (target) => {
        target.closest('.culture-squares__square').classList.remove('culture-squares__square--focus');
    }

    const focusSquare = (target) => {

        target.classList.add('culture-squares__square--focus');
    }

    /**
     * 
     * @param {*} container 
     */
    const setSquareListeners = (container) => {

        let squareItems = container.querySelectorAll('.culture-squares__square');

        squareItems.forEach(function(el){

            el.addEventListener("click", function() {
                resetSquares(container);
                focusSquare(el);
            }, false);

            let closeBtn = el.querySelector('.culture-squares__close-btn');

            closeBtn.addEventListener("click", function(e) {
                e.stopPropagation();
                removeFocusSquare(closeBtn);
            }, false);
        });
    }


    /**
     * 
     */
    const setupCultureSquares = () => {

        // console.log('setupCultureSquares');
    
        const tabElements = document.getElementsByClassName('culture-squares');

        if(tabElements.length > 0) {

            for (var i = 0; i < tabElements.length; ++i) {
                let item = tabElements[i];

                setSquareListeners(item);
            }
        }
    }

    setupCultureSquares();
});